export default {
  app_title: "Prix des carburants",
  fuel_label: "Carburant",
  fuel_95: "Essence 95",
  fuel_98: "Essence 98",
  fuel_diesel: "Diesel",
  region_label: "Région",
  region_all: "Toute l'Espagne",
  list_header: "Carburant le moins cher à proximité",
  list_show_all: "Tout afficher",
  list_empty: "Aucune station dans cette zone",
  list_expand: "Développer la liste",
  list_collapse: "Réduire la liste",
  card_navigate: "Maps",
  locate_me: "Me localiser",
  no_location_permission: "Permission refusée",
  loading: "Chargement...",
  error_loading: "Erreur de chargement",
  attribution: "© OpenStreetMap, CartoDB",
  expand_map: "Agrandir la carte",
  collapse_map: "Réduire la carte",
  station_count: "stations",
  gesture_hint: "Utilisez deux doigts pour déplacer la carte",
};
